<template>
    <div id="dppPhotos" class="dpp-photo" ref="list" :photo="dpp.photoCount">
        <template v-for="(item) in getPhotos" :key="item.index" >
            <figure @click="openPhotoView(item.cateIndex, item.index, item.i)"
                :data-index="item.i"
                :data-cateIndex="item.cateIndex"
                :data-photoIndex="item.index"
            >
                <img :class="{'img-watermark': showWatermark() }" loading="lazy" :alt="`${item.cate ? item.cate+' -' : ''} ${dpp.geo.formatAddress} photo ${item.index+1}${item.cateCount ? ' of '+item.cateCount: ''}`"   :src="item.path + (glb.isPhone ? item._p : item._r)"/>
                <figcaption v-if="item.tag">{{item.tag}}</figcaption>
            </figure>
        </template>
        <template v-for="(image,i) in getStreetAndMapImages" :key="i">
            <mvtMapStatic :class="image.type" v-if="image.show" ref="map"
                @click.prevent="openPhotoView(0, getPhotos.length + i)"
                :placeholder="image.placeholder" :eager="image.eager" :lat="dpp.geo.lat" :lng="dpp.geo.lng" :type="image.type"
                @urlLoaded="getUrl" :index="getPhotos.length + i"
                :address="dpp.geo.formatAddress" :markers="markers" :streetViewDefautType="image.fallback" :zoom="getZoom(image.type)"/>
        </template>
        <div class="photo-panel" v-if="dpp.isActive && isMounted">
            <div class="f4 text-bold">Interested in touring this home?</div>
            <button type="button" @click="openHotlead('Take a Tour')" class="btn primary regular">Request a Tour</button>
        </div>
        <div data-info :data-index="getPhotosCount" v-if="isMounted" class="photo-hotlead">
            <div class="text-center m-b-2" v-if="!testRequestTour">
                <i class="icon-pin circle large default disabled"></i>
            </div>
            <mvtHotleadForm  v-if="hotleadOpt" :options="hotleadOpt" />
            <div class="photo-mls" v-if="!dpp.showAsPR">
                <img v-if="dpp.mlsLogoSrc" :src="dpp.mlsLogoSrc" alt="dpp.mlsDescription" loading="lazy">
                <p v-if="dpp.formatMlsInfo">
                    {{dpp.formatMlsInfo}}
                </p>
            </div>
        </div>
    </div>
</template>
<script src="./dpp-photo.js"></script>

<style lang="scss">
@use "./dpp-photo.scss" as *;
</style>